<div class="navigation-back-section background-white px-0">
  <button
    class="navigation-back-section__button btn-unstyled text-black"
    #backBtn
    (click)="backToPreviousPage(backBtn)"
    [class.disabled-input]="history?.length === 1"
  >
    <ng-icon name="matArrowBack"></ng-icon>
  </button>
</div>
<!-- Login -->
<div
  class="jip-login"
  [class.login-wide-screen]="isSentConfirmationEmail || isAccountNotActive"
>
  <div
    *ngIf="logoDisplayOption === 'jip'"
    class="jip-login__logo text-center"
  >
    <app-jip-logo
      class="jip-login__logo--others"
      name="jip-logo"
      width="380px"
      height="106px"
    ></app-jip-logo>
    <app-jip-logo
      class="jip-login__logo--mobile"
      name="jip-logo"
      width="380px"
      height="106px"
    ></app-jip-logo>
  </div>
  <div
    *ngIf="logoDisplayOption === 'innovation_space'"
    class="jip-login__org-logo"
  >
    <app-organization-logo
      [className]="'filter__org-logo text-center'"
      [organizationLogo]="(centralConfig?.read(globalOrgId) | async)?.logo.url"
    ></app-organization-logo>
  </div>

  <div [ngSwitch]="credentialDisplayMode">
    <!-- Login Mode -->
    <div *ngSwitchCase="'login'">
      @if (sessionExpired && !isAccountNotActive) {
        <app-info-notice
          containerClass="mt-4 align-items-center"
          text="Login.ExpiredSessionMessage"
        ></app-info-notice>
      }

      <div class="jip-login__header d-flex justify-content-center mb-3">
        <ng-container *ngIf="!isAccountNotActive; else accountNotActive">
          <span
            class="jip-login__header-title"
            translate
            >Log in</span
          >
        </ng-container>

        <ng-template #accountNotActive>
          <span
            class="jip-login__header-title"
            translate
            >UI.UserNotActive.Your-account-not-active</span
          >
        </ng-template>
      </div>

      <div>
        <app-form-login
          #loginForm
          [email]="email"
          [assignToOrgId]="globalOrganizationId"
          (loginSuccessful)="setEventDetailPageCallback(); goBack()"
          (openAccountInactiveInformation)="onDisplayedAccountNotActive()"
          (openForgotPasswordForm)="toggleForgotPasswordForm($event)"
          (twoFactorFormOpened)="toggleTwoFactorForm($event)"
          [eventId]="eventId"
        ></app-form-login>
      </div>

      <div class="jip-login__header d-flex justify-content-center">
        <span class="jip-login__header-info"
          >{{ 'UI.Authentication.NoAccount' | translate }}:
          <a
            href=""
            class="jip-login__text-underline ms-2"
            (click)="toggleRegistrationForm($event)"
            >{{ 'UI.Authentication.SignUp' | translate }}</a
          >
        </span>
      </div>
    </div>

    <!-- Registration Mode -->
    <div *ngSwitchCase="'register'">
      <div class="jip-login__header d-flex flex-column align-items-center mb-3">
        <ng-container *ngIf="!isSentConfirmationEmail; else alreadyRegistered">
          <span
            class="jip-login__header-title mb-3"
            translate
            >Register</span
          >
        </ng-container>

        <ng-template #alreadyRegistered>
          <span
            class="jip-login__header-title"
            translate
            >UI.Registration.Please-confirm-email</span
          >
        </ng-template>
      </div>

      <div>
        <app-form-register
          #registerForm
          (loginSuccess)="goBack()"
          (sendConfirmationEmail)="onConfirmationEmailSent()"
          [assignToOrgId]="globalOrganizationId"
          [invitationTokens]="invitationTokens"
          [termOfUseUrl]="termOfUseUrl"
          [portalName]="portalName"
          [portalUrl]="portalUrl"
          [eventId]="eventId"
        ></app-form-register>
      </div>

      <ng-container *ngIf="!isSentConfirmationEmail">
        <app-login-with-linkedin-btn
          [text]="'Register with LinkedIn'"
          [assignToOrgId]="globalOrganizationId"
        ></app-login-with-linkedin-btn>
      </ng-container>

      <div
        class="jip-login__header d-flex justify-content-center"
        *ngIf="!isSentConfirmationEmail"
      >
        <span
          class="jip-login__header-info"
          translate
          >Already a member:
          <a
            href=""
            class="jip-login__text-underline"
            (click)="toggleLoginForm($event)"
            translate
            >Log in</a
          >
        </span>
      </div>
    </div>

    <!-- Forgot Password Mode -->
    <div *ngSwitchCase="'forgot-password'">
      <div class="jip-login__header d-flex justify-content-center mb-3">
        <ng-container
          *ngIf="!isPasswordResetEmailSent; else resetPasswordTittle"
        >
          <span
            class="jip-login__header-title"
            translate
            >ForgotPassword</span
          >
        </ng-container>

        <ng-template #resetPasswordTittle>
          <span
            class="jip-login__header-title"
            translate
            >ResetPassword</span
          >
        </ng-template>
      </div>

      <div>
        <app-forgot-password
          (sendConfirmationEmail)="onSentResetPasswordEmail()"
        ></app-forgot-password>
      </div>

      <div
        class="jip-login__header d-flex justify-content-center"
        *ngIf="!isSentConfirmationEmail"
      >
        <span
          class="jip-login__header-info"
          translate
          >UI.Forgot_Password.Back-to
          <a
            href=""
            class="jip-login__text-underline"
            (click)="toggleLoginForm($event)"
            translate
            >Log in</a
          >
        </span>
      </div>
    </div>

    <!-- Two Factor Mode -->
    <div *ngSwitchCase="'two-factor'">
      <div
        *ngIf="credentialOTP"
        class="jip-login__header d-flex justify-content-center mb-3"
      >
        <span
          class="jip-login__header-title"
          translate
          >Two-factor authentication</span
        >
      </div>

      <div>
        <app-form-two-factor
          (verified)="onVerifyTwoFactor()"
          (loginSuccessful)="setEventDetailPageCallback(); goBack()"
          (toggleLoginForm)="toggleLoginForm($event)"
          [eventId]="eventId"
        ></app-form-two-factor>
      </div>

      <div
        class="jip-login__header d-flex justify-content-center"
        *ngIf="!isSentConfirmationEmail"
      >
        <span
          class="jip-login__header-info"
          translate
          >UI.Forgot_Password.Back-to
          <a
            href=""
            class="jip-login__text-underline"
            (click)="toggleLoginForm($event)"
            translate
            >Log in</a
          >
        </span>
      </div>
    </div>
  </div>
</div>
